export default "/img/ZW.5fa29412a61df4d2419d4e8e02e53229.png";